import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { Favorite, FavoriteDTO } from '@common/models/favorite';

export interface FavoriteToggleResponse {
  message?: string;
  isFavorite: boolean;
  favorite?: Favorite;
  error?: string;
}

@Injectable({ providedIn: 'root' })
export class FavoriteService {

  private readonly _baseUrl = `${environment.commonApiUrl}/api/favorites`;

  constructor(private _http: HttpClient) {}

  findByUserId(userId: string): Observable<Favorite[]> {
    const params = new HttpParams().set('userId', userId);
    return this._http.get<Favorite[]>(this._baseUrl, { params });
  }

  findByUserIdAndResourceType(userId: string, resourceType: string): Observable<Favorite[]> {
    const params = new HttpParams()
      .set('userId', userId)
      .set('resourceType', resourceType);
    return this._http.get<Favorite[]>(`${this._baseUrl}/filter`, { params });
  }

  toggle(dto: FavoriteDTO): Observable<FavoriteToggleResponse> {
    return this._http.post<FavoriteToggleResponse>(this._baseUrl, dto);
  }

  delete(id: string): Observable<FavoriteToggleResponse> {
    return this._http.delete<FavoriteToggleResponse>(`${this._baseUrl}/${id}`);
  }
}
